import { convertToLocationProperty, TLocationProperty } from "../types/TLocationProperty";
import { convertToStringProperty, TStringProperty } from "../types/TStringProperty";
import { convertToReversegeoProperty, TReversegeoProperty } from "../types/TReversegeo";

export default class State {
  public location: TLocationProperty;
  public status: TStringProperty;
  public reversegeo: TReversegeoProperty;

  constructor(data?: any) {
    if (!!data) {
      const epoch = data['Epoch'];
      this.location = convertToLocationProperty(data, epoch);
      this.status = convertToStringProperty(data['status'], epoch || data['status:clock']);
      this.reversegeo = convertToReversegeoProperty(data, epoch);
    }
  }


  public update(data: any): void {
    if (!!data) {
      const epoch = data['Epoch'];
      if (data['REPORT:location:latitude']) {
        this.location = convertToLocationProperty(data, epoch);
      }
      if (data['status']) {
        this.status = convertToStringProperty(data['status'], epoch || data['status:clock']);
      }
      if (data['REPORT:reversegeo:address']) {
        this.reversegeo = convertToReversegeoProperty(data, epoch);
      }
    }
  }
}
